import { inject, injectable } from 'inversify'
import { PlayerModule } from '@/app/api';
import { QuizSessionService, QuizSessionServiceSymbol } from './service'

@injectable()
export class QuizSessionPlayerModule implements PlayerModule {
  readonly name = 'quiz-session'
  
  constructor(
    @inject(QuizSessionServiceSymbol)
    private quizSessionService: QuizSessionService) {}

  start(): void {
    this.quizSessionService.start()
  }

  reset(): void {
  }

  async stop() {
    await this.quizSessionService.stop()
  }
}
